module.exports = "/images/close-thin.svg";